import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import API from '../../../utils/API';
import DeleteAttendeeModal from './modals/deleteDefaultModal';
import BasicSectionHeader from '../../../components/views/BasicSectionHeader';
import InputField from '../../../components/inputs/inputField';
import SectionFooter from '../../../components/views/SectionFooter';
import SectionHeader from '../../../components/views/SectionHeader';
import ToggleField from '../../../components/inputs/toggleField';

class EventAttendee extends Component {
	constructor(props) {
		super(props);
		const { match: { params } } = this.props;
		const attendee = props.attendees.find((a) => a._id == params.attendeeId);
		this.props.setActiveRow(params.attendeeId)
		this.state = {
			attendee: attendee,
			editedAttendee: { ...attendee },
			customFields: {},

			selectedSection: 0,
			DeleteAttendeeModalOpen: false,
			loading: true,
			editing: false,
			agendaDates: {},
			requiredFields: {
				firstName: false,
				email: false
			},
			errorPhoneNumber: false,
			errorPhoneMessage: ''
		};
	}
	componentWillUnmount() {
		this.props.setActiveRow(null);
	}

	expandCustomField = (categoryId, categoryExpanded) => {
		const customFields = this.state.customFields;
		customFields[categoryId].expanded = !categoryExpanded;
		this.setState({ customFields: customFields });
	};

	saveInfo = () => {
		const { editedAttendee, requiredFields } = this.state;
		let valid = true;
		Object.keys(requiredFields).forEach((key) => {
			if (!editedAttendee[key] || editedAttendee[key] === '') {
				requiredFields[key] = true;
				valid = false;
			} else requiredFields[key] = false;
		});
		if (valid) {
			this.props.saveAttendee(editedAttendee, () => {
				this.setState({ attendee: { ...editedAttendee }, editing: false, requiredFields: requiredFields });
			});
		} else {
			this.setState({ requiredFields: requiredFields });
		}
	};

	toggleDelete = () => {
		this.setState({ DeleteAttendeeModalOpen: !this.state.DeleteAttendeeModalOpen });
	};

	toggleEditing = (bool) => {
		this.setState({ editing: bool });
	};

	editAttendeeField = (property, value) => {
		const editedAttendee = this.state.editedAttendee;
		editedAttendee[property] = value;
		this.setState({ editedAttendee: editedAttendee, editing: true });
	};

	editTravelFields = (data) => {
		this.setState({ editedAttendee: data });
	};

	editRoomingFields = (data) => {
		this.setState({ editedAttendee: data });
	};

	updateCustomField = (e, meta, categoryId) => {
		const customFields = this.state.customFields;
		meta.fieldType === 'checkbox'
			? (customFields[categoryId][meta._id].value = e.target.checked)
			: (customFields[categoryId][meta._id].value = e.target.value);

		this.setState({ customFields: customFields, editing: true });
	};

	cancelEdit = () => {
		const attendee = this.state.attendee;
		const fields = {};
		const requiredFields = this.state.requiredFields;
		Object.keys(requiredFields).forEach((key) => {
			requiredFields[key] = false;
		});
		this.setState({
			editedAttendee: { ...attendee },
			requiredFields: requiredFields,
			editing: false,
			customFields: fields
		});
	};

	addSession = (session) => {
		const { editedAttendee, attendee } = this.state;

		if (!editedAttendee.sessions.find((s) => session._id == s._id)) {
			editedAttendee.sessions.push(session);
			this.setState({ editedAttendee: editedAttendee, attendee: attendee }, () => {
				this.fix();
			});
		}

		if (!attendee.sessions.find((s) => s._id == session._id)) {
			attendee.sessions.push(session);
			this.setState({ editedAttendee: editedAttendee, attendee: attendee }, () => {
				this.fix();
			});
		}
	};

	verifyPhone(value) {
		const phoneNumber = value
		if (phoneNumber.length >= 8) {
			const data = JSON.stringify({ phone: phoneNumber });
			fetch("https://intl-tel-input-7366.twil.io/lookup", {
				method: "POST",
				headers: {
					'Content-Type': 'application/json'
				},
				body: data,
			})
				.then(response => {
					return response.json();
				})
				.then((json) => {
					if (json.success) {
						this.setState({ errorPhoneNumber: false });
					} else {
						this.setState({ errorPhoneMessage: json.error });
						this.setState({ errorPhoneNumber: true });
					}
				})
				.catch((error) => {
					console.error("Error with fetch operation:", error);
				});
		} else {
			this.setState({ errorPhoneNumber: false, errorPhoneMessage: null });
		}
	}

	formatPhoneNumber(cleanValue) {
		const countryRules = [
            {
                code: '+1', // US/Canada
                regex: /^(\+1)(\d{3})(\d{3})(\d{4})$/,
                format: '$1 ($2) $3-$4'
            },
            {
                code: '+7', // Russia
                regex: /^(\+7)(\d{3})(\d{3})(\d{2})(\d{2})$/,
                format: '$1 $2 $3-$4-$5'
            },
            {
                code: '+27', // South Africa
                regex: /^(\+27)(\d{2})(\d{3})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+30', // Greece
                regex: /^(\+30)(\d{3})(\d{3})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+31', // Netherlands
                regex: /^(\+31)(\d{1})(\d{4})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+32', // Belgium
                regex: /^(\+32)(\d{3})(\d{2})(\d{2})(\d{2})$/,
                format: '$1 $2 $3 $4 $5'
            },
            {
                code: '+33', // France
                regex: /^(\+33)(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})$/,
                format: '$1 $2 $3 $4 $5 $6'
            },
            {
                code: '+34', // Spain
                regex: /^(\+34)(\d{3})(\d{3})(\d{3})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+351', // Portugal
                regex: /^(\+351)(\d{3})(\d{3})(\d{3})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+352', // Luxembourg
                regex: /^(\+352)(\d{3})(\d{3})(\d{3})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+353', // Ireland
                regex: /^(\+353)(\d{2})(\d{3})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+354', // Iceland
                regex: /^(\+354)(\d{3})(\d{4})$/,
                format: '$1 $2 $3'
            },
            {
                code: '+356', // Malta
                regex: /^(\+356)(\d{4})(\d{4})$/,
                format: '$1 $2 $3'
            },
            {
                code: '+358', // Finland
                regex: /^(\+358)(\d{2})(\d{3})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+36', // Hungary
                regex: /^(\+36)(\d{2})(\d{3})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+370', // Lithuania
                regex: /^(\+370)(\d{3})(\d{2})(\d{3})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+371', // Latvia
                regex: /^(\+371)(\d{4})(\d{4})$/,
                format: '$1 $2 $3'
            },
            {
                code: '+372', // Estonia
                regex: /^(\+372)(\d{4})(\d{4})$/,
                format: '$1 $2 $3'
            },
            {
                code: '+385', // Croatia
                regex: /^(\+385)(\d{2})(\d{3})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+386', // Slovenia
                regex: /^(\+386)(\d{2})(\d{3})(\d{3})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+39', // Italy
                regex: /^(\+39)(\d{2,3})(\d{4})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+40', // Romania
                regex: /^(\+40)(\d{3})(\d{3})(\d{3})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+41', // Switzerland
                regex: /^(\+41)(\d{2})(\d{3})(\d{2})(\d{2})$/,
                format: '$1 $2 $3 $4 $5'
            },
            {
                code: '+420', // Czech Republic
                regex: /^(\+420)(\d{3})(\d{3})(\d{3})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+421', // Slovakia
                regex: /^(\+421)(\d{3})(\d{3})(\d{3})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+43', // Austria
                regex: /^(\+43)(\d{3})(\d{3})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+44', // United Kingdom
                regex: /^(\+44)(\d{4})(\d{6})$/,
                format: '$1 $2 $3'
            },
            {
                code: '+45', // Denmark
                regex: /^(\+45)(\d{2})(\d{2})(\d{2})(\d{2})$/,
                format: '$1 $2 $3 $4 $5'
            },
            {
                code: '+46', // Sweden
                regex: /^(\+46)(\d{2})(\d{3})(\d{2})(\d{2})$/,
                format: '$1 $2 $3 $4 $5'
            },
            {
                code: '+47', // Norway
                regex: /^(\+47)(\d{3})(\d{2})(\d{3})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+48', // Poland
                regex: /^(\+48)(\d{3})(\d{3})(\d{3})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+49', // Germany
                regex: /^(\+49)(\d{2,4})(\d{4,8})$/,
                format: '$1 $2 $3'
            },
            {
                code: '+52', // Mexico
                regex: /^(\+52)(\d{2})(\d{4})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+54', // Argentina
                regex: /^(\+54)(\d{1})(\d{2})(\d{4})(\d{4})$/,
                format: '$1 $2 $3 $4 $5'
            },
            {
                code: '+55', // Brazil
                regex: /^(\+55)(\d{2})(\d{5})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+56', // Chile
                regex: /^(\+56)(\d{1})(\d{4})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+57', // Colombia
                regex: /^(\+57)(\d{3})(\d{3})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+60', // Malaysia
                regex: /^(\+60)(\d{1,2})(\d{4})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+61', // Australia
                regex: /^(\+61)(\d{1})(\d{4})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+62', // Indonesia
                regex: /^(\+62)(\d{2,3})(\d{4,5})(\d{3,4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+63', // Philippines
                regex: /^(\+63)(\d{3})(\d{3})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+65', // Singapore
                regex: /^(\+65)(\d{4})(\d{4})$/,
                format: '$1 $2 $3'
            },
            {
                code: '+81', // Japan
                regex: /^(\+81)(\d{2,3})(\d{4})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+82', // South Korea
                regex: /^(\+82)(\d{2})(\d{4})(\d{4})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+852', // Hong Kong
                regex: /^(\+852)(\d{4})(\d{4})$/,
                format: '$1 $2 $3'
            },
            {
                code: '+886', // Taiwan
                regex: /^(\+886)(\d{2})(\d{4})(\d{3})$/,
                format: '$1 $2 $3 $4'
            },
            {
                code: '+90', // Turkey
                regex: /^(\+90)(\d{3})(\d{3})(\d{2})(\d{2})$/,
                format: '$1 $2 $3 $4 $5'
            },
            {
                code: '+91', // India
                regex: /^(\+91)(\d{5})(\d{5})$/,
                format: '$1 $2 $3'
            },
            {
                code: '+972', // Israel
                regex: /^(\+972)(\d{1,2})(\d{3})(\d{4})$/,
                format: '$1 $2 $3 $4'
            }
        ];
	
		for (const rule of countryRules) {
			if (cleanValue.startsWith(rule.code)) {
				return cleanValue.replace(rule.regex, rule.format);
			}
		}
		if (cleanValue.startsWith("+")) {
			return cleanValue.replace(
				/^(\+\d{1,3})(\d{1,4})(\d{3})(\d{4})$/,
				'$1-$2-$3-$4'
			);
		}
		return cleanValue.replace(
			/^(\d{3})(\d{3})(\d{4})$/,
			'($1) $2-$3'
		);
	}

	render() {
		const { DeleteAttendeeModalOpen, loading, editing, attendee, editedAttendee, requiredFields } = this.state;
		const { match: { params }, program } = this.props;
		//const attendee = this.props.attendees.find((a) => a._id == params.attendeeId);
		return (
			<div className="sectionContainer">
				<SectionHeader
					title={`${attendee.firstName} ${attendee.lastName}`}
					titleIcon={
						attendee.profilePicture ? (
							<img src={attendee.profilePicture} style={{ maxWidth: '100%', overflow: 'clip' }} />
						) : (
							<div className="calibreBold fs-30">
								{attendee.firstName.toUpperCase().charAt(0)}
								{attendee.lastName.toUpperCase().charAt(0)}
							</div>
						)
					}
					enableLastLink={true}
					closeButton={true}
					subActions={[{ onClick: this.toggleDelete, label: <span><i className='las la-trash mr-10'></i>Delete Attendee</span> }]}
				/* 	breadcrumbs={[
						{
							name: program.name
						},
						{
							name: 'Event Attendees'
						}
					]} */
				/>
				<div className="sectionBody">
					<h2 className='blockHeader'>Information</h2>
					<div className="sectionBlock">
						<InputField
							label="First Name"
							required={true}
							errorTrigger={requiredFields.firstName}
							value={editedAttendee.firstName}
							type="text"
							onChange={(e) => this.editAttendeeField('firstName', e.target.value)}
						/>
						<InputField
							label="Last Name"
							value={editedAttendee.lastName}
							type="text"
							onChange={(e) => this.editAttendeeField('lastName', e.target.value)}
						/>
						<InputField
							label="Email"
							required={true}
							errorTrigger={requiredFields.email}
							value={editedAttendee.email}
							type="text"
							onChange={(e) => this.editAttendeeField('email', e.target.value)}
						/>
						<InputField
							label="Phone Number"
							value={editedAttendee.phoneNumber}
							type="tel"
							errorTrigger={this.state.errorPhoneNumber}
							errorMessage={this.state.errorPhoneMessage}
							onChange={(e) => {
								let cleanValue = e.target.value.replace(/[^0-9+]/g, '');
								cleanValue = this.formatPhoneNumber(cleanValue);
								this.verifyPhone(cleanValue);
								this.editAttendeeField('phoneNumber', cleanValue);
							}}
						/>
						<InputField
							label="Title"
							value={editedAttendee.title}
							type="text"
							onChange={(e) => this.editAttendeeField('title', e.target.value)}
						/>
						<InputField

							label="Company"
							value={editedAttendee.company}
							type="text"
							onChange={(e) => this.editAttendeeField('company', e.target.value)}
						/>
						<ToggleField
							label="Text Message Opt In"
							checked={editedAttendee.textMessageOptIn}
							icons={false}
							onChange={(e) => this.editAttendeeField('textMessageOptIn', e.target.checked)}
						/>
						<InputField
							label="Dietary Preference"
							value={editedAttendee.dietaryPreference}
							type="text"
							onChange={(e) => this.editAttendeeField('dietaryPreference', e.target.value)}
						/>
						<InputField
							label="Food Allergies"
							value={editedAttendee.foodAllergies}
							type="text"
							onChange={(e) => this.editAttendeeField('foodAllergies', e.target.value)}
						/>
						<InputField
							label="Emergency Contact Name"
							value={editedAttendee.emergencyContactName}
							type="text"
							onChange={(e) => this.editAttendeeField('emergencyContactName', e.target.value)}
						/>
						<InputField
							label="Emergency Contact Phone Number"
							value={editedAttendee.emergencyContactPhoneNumber}
							type="tel"
							errorTrigger={this.state.errorPhoneNumber}
							errorMessage={this.state.errorPhoneMessage}
							onChange={(e) => {
								let cleanValue = e.target.value.replace(/[^0-9+]/g, '');
								cleanValue = this.formatPhoneNumber(cleanValue);
								this.verifyPhone(cleanValue);
								this.editAttendeeField('emergencyContactPhoneNumber', cleanValue);
							}}
						/>
						<InputField
							label="Address"
							value={editedAttendee.address}
							type="text"
							onChange={(e) => this.editAttendeeField('address', e.target.value)}
						/>
						<InputField
							label="Address 2"
							value={editedAttendee.address2}
							type="text"
							onChange={(e) => this.editAttendeeField('address2', e.target.value)}
						/>
						<InputField
							label="City"
							value={editedAttendee.city}
							type="text"
							onChange={(e) => this.editAttendeeField('city', e.target.value)}
						/>
						<InputField
							label="State"
							value={editedAttendee.state}
							type="text"
							onChange={(e) => this.editAttendeeField('state', e.target.value)}
						/>
						<InputField
							label="Zip"
							value={editedAttendee.zip}
							type="text"
							onChange={(e) => this.editAttendeeField('zip', e.target.value)}
						/>
						<InputField
							label="Country"
							value={editedAttendee.country}
							type="text"
							onChange={(e) => this.editAttendeeField('country', e.target.value)}
						/>
					</div>
				</div>
				<SectionFooter
					editing={editing}
					cancelEdit={this.cancelEdit}
					saveEdit={this.saveInfo}
					updatedAt={attendee.updatedAt} />
				{DeleteAttendeeModalOpen && (
					<DeleteAttendeeModal
						isOpen={DeleteAttendeeModalOpen}
						toggle={this.toggleDelete}
						attendee={attendee}
						title={`Delete Attendee`}
						message={`You are about to delete, this is irreversible,
					would you like to continue?`}
						submit={() => {
							const attendees = {};
							attendees[attendee._id] = true;
							this.props.deleteAttendee(
								attendees,
								this.props.history.push('./'),
							);
						}}
					/>
				)}
			</div>
		);
	}
}

export default withRouter(EventAttendee);
